<template>
  <div id="main-banner" class="swiper-container multi-banner" v-on-display="{sectionInfo, context: this}">
    <h2 tabindex="0" class="ir">빅배너</h2>
<!--    <a href="#voucher-banner" class="big-banner-nav ir">빅배너 영역은 여러 배너가 자동으로 움직이는 곳이며, 3회 반복한 뒤에 다음 영역으로 이동하실 수 있습니다. 만약 건너뛰기를 원하신다면 엔터키 또는 스페이스바를 눌러주세요.</a>-->
    <div class="main01-nav">
      <button @click.prevent="clickSwiperButton()" :class="playButtonClass">
        <template v-if="isPlay"> 빅배너 슬라이더 일시정지 </template>
        <template v-else> 빅배너 슬라이더 자동 재생 </template>
      </button>
      <div class="swiper-pagination"></div>
    </div>
    <button type="button" class="swiper-button-prev">이전 배너</button>
    <button type="button" class="swiper-button-next">다음 배너</button>
    <template v-if="cellList.length > 0">
      <div class="swiper-wrapper" ref="multi-banner">
        <div v-for="(cell, index) in cellList" :key="index" class="swiper-slide component-list">
            <div class="image-area" :style="getBackgroundStyle(cell)">
              <a>
                <img :src="getTextImage(cell)" :alt="getAltText(cell)">
              </a>
            </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import _ from 'lodash'
import fp from 'lodash/fp'
import { getBand, getCellEventObject, getCellList } from '@/common/utils/gnb.fp'
import { ON_CLICK_CELL } from '@/common/resources/const'
import { bannerLink } from '@/common/utils/common'
import { fetchOnContent } from '@/common/utils/request.common'
import { onDisplay } from '@/common/resources/directives'
import Swiper from '@/mixins/swiper'
import CellMixin from '@/mixins/cell.mixin'
export default {
  name: 'TemplateBigBanner',
  mixins: [
    Swiper,
    CellMixin
  ],
  directives: {
    onDisplay
  },
  props: {
    sectionInfo: {
      type: Object
    }
  },
  data () {
    return {
      isPlay: true,
      cellList: [],
      bandInfo: null,
      swiperOptions: {
        autoplay: 3500,
        autoplayDisableOnInteraction: false,
        pagination: '.swiper-pagination',
        paginationType: 'bullets',
        paginationClickable: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        loop: true,
        nextButton: '.swiper-button-prev',
        prevButton: '.swiper-button-next',
        a11y: true,
        onClick: this.onClickProcessor
      }
    }
  },
  methods: {
    onClickProcessor (swiper) {
      const clickedSlide = _.get(swiper, 'clickedSlide', null)
      if (clickedSlide === null) return
      const idx = clickedSlide.getAttribute('data-swiper-slide-index')
      if (idx !== '') {
        const { onClick, onNavigation } = fp.flow(fp.get('event_list'), getCellEventObject)(this.cellList[idx])
        this.$events.$emit(ON_CLICK_CELL, onClick)
        const url = _.get(onNavigation, 'url', '')
        if (url !== '') bannerLink(url)
      }
    },
    clickSwiperButton () {
      if (this.isPlay) {
        this.swiper.stopAutoplay()
      } else {
        this.swiper.startAutoplay()
      }
      this.isPlay = !this.isPlay
    },
    async setData () {
      const response = await fetchOnContent(this.sectionInfo)
      this.bandInfo = getBand(response)
      const cellList = getCellList(response)
      if (cellList.length === 1) {
        this.cellList = [cellList[0], cellList[0], cellList[0]]
      } else {
        this.cellList = cellList
      }
      this.initSwiperFromEl(this.$refs.multiBanner)
    },
    getTextImage (cell) {
      return `https://` + _.get(cell, 'image.landscape.text', '')
    },
    getBackgroundStyle (cell) {
      return `background-image: url('https://${_.get(cell, 'image.landscape.background', '')}');`
    },
    getAltText (cell) {
      return _.get(cell, 'title_list.0.text', '')
    }
  },
  computed: {
    playButtonClass () {
      return `${this.isPlay ? 'btn-pause' : 'btn-play'} ir`
    }
  },
  created () {
    this.setData()
  },
  beforeDestroy () {
    this.swiper && this.swiper.destroy && this.swiper.destroy()
  }
}
</script>
